import React, { useState } from "react";
import { Btn, Input } from "./ui";
import { isCompactViewport, T} from "../lib/globals";
import { CattleIcon } from "../lib/icons";

function AnimalOpcoes({ activeBreeds, activePurposes, defaultPurposes, onSaveBreeds, onSavePurposes, show }) {
  const [breeds,     setBreeds]     = useState([...activeBreeds]);
  const [purposes,   setPurposes]   = useState([...activePurposes]);
  const [newBreed,   setNewBreed]   = useState("");
  const [newPurpose, setNewPurpose] = useState("");
  const [subtab,     setSubtab]     = useState("racas");

  function addBreed() {
    if(!newBreed.trim()){show("Informe o nome da raça.","error");return;}
    if(breeds.includes(newBreed.trim())){show("Raça já existe.","error");return;}
    const updated=[...breeds, newBreed.trim()];
    setBreeds(updated); onSaveBreeds(updated);
    setNewBreed(""); show("✅ Raça adicionada!");
  }
  function removeBreed(b) {
    const updated=breeds.filter(x=>x!==b);
    setBreeds(updated); onSaveBreeds(updated);
  }
  function addPurpose() {
    if(!newPurpose.trim()){show("Informe a finalidade.","error");return;}
    if(purposes.includes(newPurpose.trim())){show("Finalidade já existe.","error");return;}
    const updated=[...purposes, newPurpose.trim()];
    setPurposes(updated); onSavePurposes(updated);
    setNewPurpose(""); show("✅ Finalidade adicionada!");
  }
  function removePurpose(p) {
    const updated=purposes.filter(x=>x!==p);
    setPurposes(updated); onSavePurposes(updated);
  }
  function resetBreeds() { setBreeds([]); onSaveBreeds([]); show("✅ Campo livre."); }
  function resetPurposes() { setPurposes([...defaultPurposes]); onSavePurposes(defaultPurposes); show("✅ Restaurado!"); }

  const compactListsLayout = isCompactViewport();
  const listStyle = {display:"grid",gridTemplateColumns:compactListsLayout?"1fr":"repeat(auto-fill,minmax(200px,1fr))",gap:8};
  const itemStyle = {display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",background:T.card2,borderRadius:10,border:`1px solid ${T.border}`};

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:20}}>
        <Btn variant={subtab==="racas"?"primary":"ghost"} onClick={()=>setSubtab("racas")}><span style={{display:"inline-flex",alignItems:"center",gap:6}}><CattleIcon size={18} /> Raças</span></Btn>
        <Btn variant={subtab==="finalidades"?"primary":"ghost"} onClick={()=>setSubtab("finalidades")}>🎯 Finalidades</Btn>
      </div>
      {subtab==="racas"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:compactListsLayout?"flex-start":"center",flexDirection:compactListsLayout?"column":"row",gap:compactListsLayout?10:0,marginBottom:16}}>
            <div style={{fontWeight:700,color:T.text,fontSize:15,display:"inline-flex",alignItems:"center",gap:8}}><CattleIcon size={20} /> Raças do Rebanho</div>
            <Btn size="sm" variant="ghost" onClick={resetBreeds}>↩ Campo livre</Btn>
          </div>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            <Input value={newBreed} onChange={e=>setNewBreed(e.target.value)} placeholder="Nova raça..." style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addBreed()}/>
            <Btn onClick={addBreed}>+ Adicionar</Btn>
          </div>
          <div style={listStyle}>
            {breeds.map(b=>(
              <div key={b} style={itemStyle}>
                <span style={{fontSize:13,fontWeight:500,color:T.text,display:"inline-flex",alignItems:"center",gap:6}}><CattleIcon size={16} /> {b}</span>
                <button onClick={()=>removeBreed(b)} style={{background:"none",border:"none",color:T.red,cursor:"pointer",fontSize:18,padding:"2px 6px",lineHeight:1}}>×</button>
              </div>
            ))}
            {breeds.length===0&&<div style={{gridColumn:"1/-1",color:T.muted,fontSize:13,padding:"20px 0"}}>Campo de texto livre no formulário do animal.</div>}
          </div>
        </div>
      )}
      {subtab==="finalidades"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:compactListsLayout?"flex-start":"center",flexDirection:compactListsLayout?"column":"row",gap:compactListsLayout?10:0,marginBottom:16}}>
            <div style={{fontWeight:700,color:T.text,fontSize:15}}>🎯 Finalidades</div>
            <Btn size="sm" variant="ghost" onClick={resetPurposes}>↩ Restaurar padrão</Btn>
          </div>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            <Input value={newPurpose} onChange={e=>setNewPurpose(e.target.value)} placeholder="Nova finalidade..." style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addPurpose()}/>
            <Btn onClick={addPurpose}>+ Adicionar</Btn>
          </div>
          <div style={listStyle}>
            {purposes.map(p=>(
              <div key={p} style={itemStyle}>
                <span style={{fontSize:13,fontWeight:500,color:T.text}}>🎯 {p}</span>
                <button onClick={()=>removePurpose(p)} style={{background:"none",border:"none",color:T.red,cursor:"pointer",fontSize:18,padding:"2px 6px",lineHeight:1}}>×</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default AnimalOpcoes;
export { AnimalOpcoes };
